import { awards as awardsSettings } from '@settings';
import { Body2, Overline } from '@xo-union/tk-ui-typography';
import { useAtomValue } from 'jotai';
import React, { useMemo } from 'react';
import { vendorAwardsAtom } from '../../jotai/storefront/awards-summary';
import { AwardSingleItem } from '../../pages/Storefront/components/award-single-item/AwardSingleItem';
import { withinDateRange } from '../../utils/withinDateRange';
import Styles from './styles.scss';

const { startDate, endDate } = awardsSettings;

export const AboutSingleAward = () => {
	const awards = useAtomValue(vendorAwardsAtom);

	const awardCount = useMemo(() => {
		return awards
			.filter((a) => a.type === 'BOW')
			.filter(
				(a) => !(a.year === 2026 && !withinDateRange({ startDate, endDate })),
			).length;
	}, [awards]);

	if (awardCount === 0) {
		return null;
	}

	return (
		<div className={Styles.awardsContainer}>
			<AwardSingleItem />
			<div>
				<Overline className={Styles.title} bold>
					AWARD WINNER {awardCount > 1 ? `(${awardCount}X)` : ''}
				</Overline>
				<Body2>Thanks to recommendations from couples on The Knot</Body2>
			</div>
		</div>
	);
};
